// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
import { relativeFontSizeToBase16 } from '@atlaskit/editor-shared-styles';
import { B100, N100, N30, N400 } from '@atlaskit/theme/colors';
// Normal .className gets overridden by input[type=text] hence this hack to produce input.className
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export var panelTextInput = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
  'input&': {
    background: 'transparent',
    border: "2px solid ".concat("var(--ds-border, ".concat(N30, ")")),
    borderRadius: 0,
    boxSizing: 'content-box',
    color: "var(--ds-text-subtle, ".concat(N400, ")"),
    flexGrow: 1,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    fontSize: relativeFontSizeToBase16(13),
    lineHeight: '20px',
    padding: "var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-400, 32px)", " ", "var(--ds-space-075, 6px)", " ", "var(--ds-space-100, 8px)"),
    minWidth: '145px',
    /* Hides IE10+ built-in [x] clear input button */
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
      display: 'none'
    },
    '&:focus': {
      outline: 'none',
      borderColor: "var(--ds-border-focused, ".concat(B100, ")")
    },
    '&::placeholder': {
      color: "var(--ds-text-subtlest, ".concat(N100, ")")
    }
  }
});
export var panelTextInputWithCustomWidth = function panelTextInputWithCustomWidth(width) {
  return css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    'input&': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      width: "".concat(width, "px")
    }
  });
};